import { createIcon } from '@chakra-ui/react';
import colors from 'src/theme/colors';

export default createIcon({
  displayName: 'TickCircleIcon',
  viewBox: '0 0 90 90',
  path: [
    <circle cx="45" cy="45" r="42" stroke={colors.podcastPurple} strokeWidth="6" fill="none" />,
    <path
      d="M30 48L40 59L62 35"
      stroke={colors.podcastPurple}
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
  ],
});
